// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_GET_URL_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/getUrl.js");
var ___CSS_LOADER_URL_IMPORT_0___ = require("../../../../public/commonDownArrow.svg");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AdminDashboard-userBox-z48Me {
	-webkit-box-shadow: 0px 11px 16px #DCD8FF73;
	        box-shadow: 0px 11px 16px #DCD8FF73;
	border: 2px solid var(--primary-border);
	border-radius: 12px;
	padding: 19px 0px 0px;
	text-align: center;
}

.AdminDashboard-commonBg-hOkVI {
	background: #F4F2FF 0% 0% no-repeat padding-box;
	border-radius: 12px;
	padding: 20px;
}

.AdminDashboard-userBoxBG-NN6MD {
	background: transparent linear-gradient(62deg, #FFDFD9 0%, #A3B2FF 100%) 0% 0% no-repeat padding-box;
	border: 2px solid #FFF8F2;
}

.AdminDashboard-displayGrid-gTw7_ {
	display: grid;
	grid-template-columns: 33% 33% 33%;
	padding: 33px 6px 0px;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	justify-items: center;
	-webkit-box-pack: justify;
	    -ms-flex-pack: justify;
	        justify-content: space-between;
}

.AdminDashboard-listingBoxBg-lz5dG {
	background: transparent linear-gradient(62deg, #FFD9FC 0%, #FFE991 100%) 0% 0% no-repeat padding-box;
	border: 2px solid #FFF8F2;
}

.AdminDashboard-reservationBox-_BW6Q {
	background: var(--common-gray-bg-color);
	border: 2px solid var(--primary-white-bg);
	border-radius: 12px;
	text-align: center;
	padding: 33px;
}

.AdminDashboard-reservationBg-d4RGs {
	border: 1px solid var(--primary-border);
	padding: 20px;
	border-radius: 12px;
}

.AdminDashboard-columnGrid-svTzD {
	display: grid;
	grid-template-columns: 50% 50%;
}

.AdminDashboard-marginOne-wjOWr {
	margin: 0px 15px 30px 0px;
}

.AdminDashboard-marginTwo-p45r7 {
	margin: 0px 0px 30px 15px;
}

.AdminDashboard-reservationGrid-sDdmv {
	display: grid;
	grid-template-columns: 32% 36% 32%;
}

.AdminDashboard-reservationMarginRight-tnyEi {
	margin-right: 21px;
}

.AdminDashboard-reservationMarginLeft-x0IVI {
	margin-left: 21px;
}

.AdminDashboard-backgroundBgBlur-Rqht3 {
	position: relative;
}

.AdminDashboard-backgroundBgBlur-Rqht3::after {
	content: '';
	width: 72px;
	height: 72px;
	background-color: #FFD8B9;
	-webkit-filter: blur(17px);
	        filter: blur(17px);
	position: absolute;
	top: 0;
	left: 0;
	right: 0;
	margin: 0 auto;
}

.AdminDashboard-imgZindex-E2kqC {
	position: relative;
	z-index: 2;
}

.AdminDashboard-backgroundBgBlurTwo-Cp5Gd::after {
	background-color: #FFB9B9;
}

.AdminDashboard-motheListing-wMWbR {
	display: block;
}

/* start */

.AdminDashboard-dashboardHeaderFlexWrapper-ot7Y6 {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-pack: justify;
	    -ms-flex-pack: justify;
	        justify-content: space-between;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	-ms-flex-wrap: wrap;
	    flex-wrap: wrap;
	gap: 12px;
}

.AdminDashboard-dashboardCardGridWrapper-ZaQbs {
	display: grid;
	grid-template-columns: repeat(4, 1fr);
	gap: 24px;
}

/* card */

.AdminDashboard-dashboardCard-htWwU {
	border: 1px solid var(--primary-border);
	border-radius: 12px;
}

.AdminDashboard-dashboardCardHeaderWrapper-fdLLX {
	padding: 18px;
	border-bottom: 1px solid var(--primary-border);
}

.AdminDashboard-dashboardCardHeaderTitleFlex-cdgDr {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	-webkit-box-pack: justify;
	    -ms-flex-pack: justify;
	        justify-content: space-between;
	gap: 12px;
}

.AdminDashboard-dashboardCardIconWrapper-G_KB_ {
	padding: 8px;
	border-radius: 8px;
	background: var(--icon-background);
	width: 40px;
	height: 40px;
	padding: 10px;
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-pack: center;
	    -ms-flex-pack: center;
	        justify-content: center;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	color: var(--icon-color);
	-ms-flex-negative: 0;
	    flex-shrink: 0;
}

.AdminDashboard-dashboardCardIconWrapper-G_KB_ svg {
	width: 100%;
	height: 100%;
}

.AdminDashboard-dashboardEaringsReportWrapper-GXsmu {
	padding: 18px;
}

.AdminDashboard-dashboardCardRow-b_Yqp {
	display: grid;
	grid-template-columns: repeat(2, 1fr);
	gap: 12px;
	margin-bottom: 12px;
	font-size: 14px;
}

.AdminDashboard-dashboardCardRow-b_Yqp>span:first-child {
	color: var(--tertiary-foreground);
	text-align: start;
}

.AdminDashboard-dashboardCardRow-b_Yqp>span:last-child {
	color: var(--common-text-color);
	text-align: end;
}

.AdminDashboard-dashboardCardLinkContainer-aiZx1 {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-pack: end;
	    -ms-flex-pack: end;
	        justify-content: end;
}

.AdminDashboard-dashboardCardLink-aRJur {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	gap: 4px;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	font-size: 14px;
}

.AdminDashboard-dashboardCardLink-aRJur svg {
	width: 6px;
	height: 10px;
	position: relative;
	top: 1px;
}

.AdminDashboard-dateRangeBatch-HZGZG {
	padding: 10px 18px;
	border-radius: 24px;
	background: var(--common-gray-bg-color);
	font-size: 16px;
	display: -webkit-inline-box;
	display: -ms-inline-flexbox;
	display: inline-flex;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	gap: 4px;
	border: 1px solid var(--primary-border);
}

.AdminDashboard-dateRangeBatch-HZGZG svg {
	width: 20px;
	height: 20px;
	-ms-flex-negative: 0;
	    flex-shrink: 0;
}

.AdminDashboard-dashboardRevenueAndPlatformEarningsGridWrapper-sM8BF {
	display: grid;
	gap: 24px;
}

.AdminDashboard-dashboardRevenueCard-YXAdk,
.AdminDashboard-platformEarningsCard-RxgR_ {
	padding: 18px;
	border: 1px solid var(--primary-border);
	border-radius: 12px;
}

.AdminDashboard-revenueChartDotWrapper-ujblY {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	gap: 12px;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	-webkit-margin-start: auto;
	        margin-inline-start: auto
}

.AdminDashboard-revenueChartDotWrapper-ujblY .AdminDashboard-chartDotText-MWXs0 {
	position: relative;
	-webkit-padding-start: 18px;
	        padding-inline-start: 18px;
}

.AdminDashboard-revenueChartDotWrapper-ujblY .AdminDashboard-chartDotText-MWXs0::before {
	position: absolute;
	content: '';
	width: 8px;
	height: 8px;
	background-color: var(--btn-primary-bg);
	border-radius: 50%;
	left: 0;
	top: 4px;
}

.AdminDashboard-revenueChartDotWrapper-ujblY .AdminDashboard-chartDotText-MWXs0:last-child::before,
.AdminDashboard-revenueChartDotWrapper-ujblY .AdminDashboard-chartDotTextFee-_B8Yk::before {
	background-color: var(--common-link-color);
}

.AdminDashboard-revenueChartDotWrapper-ujblY .AdminDashboard-chartDotTextFee-_B8Yk {
	font-weight: 500;
	color: var(--common-text-color);
}

.AdminDashboard-chartSectionHeaderFlex-hbpY1 .AdminDashboard-revenueFeeSubtitle-plimi {
	color: var(--tertiary-foreground);
	font-size: 14px;
	margin-top: 4px;
}

.AdminDashboard-dashboardRevenueCard-YXAdk .AdminDashboard-chartSectionHeaderFlex-hbpY1 {
	-webkit-box-align: start;
	    -ms-flex-align: start;
	        align-items: flex-start;
}

.AdminDashboard-chartSectionHeaderFlex-hbpY1 {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	gap: 12px;
	-ms-flex-wrap: wrap;
	    flex-wrap: wrap;
	-webkit-box-pack: justify;
	    -ms-flex-pack: justify;
	        justify-content: space-between;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
}

.AdminDashboard-dashboardReservationTableHeader-ytHwq {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-pack: justify;
	    -ms-flex-pack: justify;
	        justify-content: space-between;
	padding: 18px;
	border: 1px solid var(--primary-border);
	border-bottom: 0;
	border-radius: 6px 6px 0 0;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	gap: 12px;
	-ms-flex-wrap: wrap;
	    flex-wrap: wrap;
}

/* date filter start */

.AdminDashboard-dashboardDateFilterWrapper-J6sen {
	position: relative;
	z-index: 2;
	-webkit-margin-start: auto;
	        margin-inline-start: auto;
}

.AdminDashboard-dashboardDateFilterPickerAndButtonWrapper-GGv34 {
	position: absolute;
	right: 0;
	border-radius: 12px;
	-webkit-box-shadow: 0px 5px 9px 1px #8080801f;
	        box-shadow: 0px 5px 9px 1px #8080801f;
	border: 1px solid var(--primary-border);
	overflow: hidden;
	background-color: white;
	top: 52px;
}

.AdminDashboard-dashboardDateFilterPickerInnerWrapper-mFma5 {
	display: grid;
	grid-template-columns: 300px 1fr;
}

.AdminDashboard-dashboardDateFilterButtonWrapper-fvSi4 {
	display: -webkit-inline-box;
	display: -ms-inline-flexbox;
	display: inline-flex;
	-webkit-box-orient: vertical;
	-webkit-box-direction: normal;
	    -ms-flex-direction: column;
	        flex-direction: column;
	-webkit-box-align: start;
	    -ms-flex-align: start;
	        align-items: flex-start;
	-webkit-box-pack: justify;
	    -ms-flex-pack: justify;
	        justify-content: space-between;
	gap: 10px;
	padding: 18px;
	background: var(--common-gray-bg-color);
	border-right: 1px solid var(--primary-border);
}

.AdminDashboard-dashboardDateFilterButtonInnerWrapper-LrA5g {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-orient: vertical;
	-webkit-box-direction: normal;
	    -ms-flex-direction: column;
	        flex-direction: column;
	-webkit-box-align: start;
	    -ms-flex-align: start;
	        align-items: flex-start;
	gap: 4px;
}

.AdminDashboard-dashboardDateFilterButtonInnerWrapper-LrA5g label {
	margin-bottom: 0;
}

.AdminDashboard-dashboardDateFilterButton-jzGKT {
	background: transparent;
	border: 0;
	color: var(--tertiary-foreground);
	padding: 0 12px;
}

.AdminDashboard-dashboardDateFilterButtonActive-GZIOR {
	border: 1px solid var(--primary-border);
	background: white;
	padding: 6px 12px;
	border-radius: 6px;
	color: var(--common-text-color);
}

.AdminDashboard-dashboardDateFilterRadioLabel-eNKzU {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	gap: 8px;
	cursor: pointer;
	padding: 2px 0;
}

.AdminDashboard-dashboardDateFilterRadioInput-iIh6n {
	width: 18px;
	height: 18px;
	margin: 0;
	accent-color: #000;
	accent-color: var(--btn-primary-bg, #000);
	cursor: pointer;
	-ms-flex-negative: 0;
	    flex-shrink: 0;
}

.AdminDashboard-dashboardDateFilterRadioText-cI6ZC {
	color: var(--tertiary-foreground);
	font-size: 14px;
}

.AdminDashboard-dashboardDateFilterRadioLabel-eNKzU:has(.AdminDashboard-dashboardDateFilterRadioInput-iIh6n:checked) .AdminDashboard-dashboardDateFilterRadioText-cI6ZC {
	color: var(--common-text-color);
	font-weight: 500;
}

.AdminDashboard-dateFilterClearLink-K0Kaw {
	background: none;
	border: none;
	padding: 0;
	font-size: 14px;
	color: #0066cc;
	color: var(--common-link-color, #0066cc);
	text-decoration: none;
	cursor: pointer;
	text-align: left;
}

.AdminDashboard-dateFilterClearLink-K0Kaw:hover {
	text-decoration: underline;
}

.AdminDashboard-dateFilterApplyButton-mwbA0 {
	-ms-flex-negative: 0;
	    flex-shrink: 0;
	padding: 4px 12px;
}

.AdminDashboard-dateFilterApplyAndClearButtonWrapper-bT1Ha {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-orient: horizontal;
	-webkit-box-direction: normal;
	    -ms-flex-direction: row;
	        flex-direction: row;
	-webkit-box-pack: justify;
	    -ms-flex-pack: justify;
	        justify-content: space-between;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	width: 100%;
	gap: 12px;
}

.AdminDashboard-dateFilterSelectContainer-iRVc3 {
	background: white;
	border: 1px solid var(--primary-border);
	border-radius: 6px;
	padding: 10px 12px;
	-webkit-padding-end: 30px;
	padding-inline-end: 40px;
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	gap: 4px;
	background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) !important;
	background-repeat: no-repeat;
	background-position: calc(100% - 15px) 50%;
	background-size: 12px 25px !important;
	font-size: 16px;

}

.AdminDashboard-dateFilterSelectContainer-iRVc3 span {
	white-space: nowrap;
	overflow: hidden;
}

.AdminDashboard-dateFilterSelectContainer-iRVc3 svg {
	width: 20px;
	height: 20px;
}

.AdminDashboard-platformEarningsRow-bPm20 {
	display: grid;
	grid-template-columns: repeat(2, 1fr);
	gap: 12px;
	font-size: 14px;
	padding: 18px;
	border: 1px solid var(--primary-border);
	border-radius: 30px;
	color: var(--tertiary-foreground);
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
}

.AdminDashboard-platformEarningsRow-bPm20>div:last-child {
	text-align: end;
	color: var(--common-text-color);
	font-weight: 500;
}

.AdminDashboard-platformEarningsRowDotFlexContainer-xOHXv {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	gap: 6px;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
}

.AdminDashboard-platformEarningsRowDot-beKz9 {
	width: 12px;
	height: 12px;
	border-radius: 50%;
	-ms-flex-negative: 0;
	    flex-shrink: 0;
}

.AdminDashboard-platformEarningsCardInnerGrid-IaNFa {
	display: grid;
	grid-template-columns: repeat(2, 1fr);
	gap: 36px;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;

}

.AdminDashboard-platformEarningsRowWrapper-ihmOC {
	display: -webkit-inline-box;
	display: -ms-inline-flexbox;
	display: inline-flex;
	gap: 24px;
	-webkit-box-orient: vertical;
	-webkit-box-direction: normal;
	    -ms-flex-direction: column;
	        flex-direction: column;
	max-width: 430px;
}

.AdminDashboard-platformEarningsChart-V4RkW {
	width: 250px;
	height: 250px;
	margin: auto;
}

.AdminDashboard-noDataTitle-umUrF {
	font-size: 18px;
	font-weight: 600;
	margin-bottom: 6px;
	text-align: center;
}

.AdminDashboard-noDataDescription-rywUI {
	color: var(--modalText-color);
	font-size: 14px;
	margin: 0;
	text-align: center;
}

.AdminDashboard-platformEarningsCardNoData-bZ3UO {
	min-height: 200px;
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-pack: center;
	    -ms-flex-pack: center;
	        justify-content: center;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	-webkit-box-orient: vertical;
	-webkit-box-direction: normal;
	    -ms-flex-direction: column;
	        flex-direction: column;
}

.AdminDashboard-dateTooltipIcon-sO0Ss {
	position: relative;
	top: -2px;
	-webkit-padding-start: 2px;
	        padding-inline-start: 2px;
}

@media screen and (max-width: 1300px) {
	.AdminDashboard-dashboardCardGridWrapper-ZaQbs {
		grid-template-columns: repeat(2, 1fr);
	}
}

@media screen and (max-width: 991px) {

	.AdminDashboard-dashboardCardGridWrapper-ZaQbs,
	.AdminDashboard-dashboardRevenueAndPlatformEarningsGridWrapper-sM8BF {
		grid-template-columns: 100%;
	}
}

@media screen and (max-width: 767px) {

	.AdminDashboard-dashboardDateFilterPickerInnerWrapper-mFma5,
	.AdminDashboard-platformEarningsCardInnerGrid-IaNFa {
		grid-template-columns: 100%;
	}

	.AdminDashboard-dashboardDateFilterButtonWrapper-fvSi4 {
		gap: 24px;
		-webkit-box-ordinal-group: 3;
		    -ms-flex-order: 2;
		        order: 2;
		border-right: 0;
		border-top: 1px solid var(--primary-border);
	}

	.AdminDashboard-dashboardDateFilterButton-jzGKT {
		font-size: 16px;
		width: 100%;
		text-align: center;
	}

	.AdminDashboard-platformEarningsCardInnerGrid-IaNFa>div:first-child {
		-webkit-box-ordinal-group: 3;
		    -ms-flex-order: 2;
		        order: 2;
		margin: 0 auto;
	}

	.AdminDashboard-platformEarningsCardInnerGrid-IaNFa>div:last-child {
		-webkit-box-ordinal-group: 2;
		    -ms-flex-order: 1;
		        order: 1;
	}

	.AdminDashboard-chartLabelHiddenMobile-MkkOT {
		display: none;
	}

	.AdminDashboard-chartSectionHeaderFlex-hbpY1 {
		-webkit-box-orient: vertical;
		-webkit-box-direction: normal;
		    -ms-flex-direction: column;
		        flex-direction: column;
		-webkit-box-align: start;
		    -ms-flex-align: start;
		        align-items: flex-start;
	}

	.AdminDashboard-revenueChartDotWrapper-ujblY {
		-webkit-margin-start: unset;
		        margin-inline-start: unset;
		-ms-flex-wrap: wrap;
		    flex-wrap: wrap;
	}

	.AdminDashboard-dashboardDateFilterButtonInnerWrapper-LrA5g {
		width: 100%;
	}

	.AdminDashboard-dateFilterApplyButton-mwbA0 {
		font-size: 14px !important;
	}

	.AdminDashboard-dateFilterSelectContainer-iRVc3 {
		max-width: 280px;
	}
}`, "",{"version":3,"sources":["webpack://./src/components/siteadmin/AdminDashboard/AdminDashboard.css"],"names":[],"mappings":"AAAA;CACC,2CAAmC;SAAnC,mCAAmC;CACnC,uCAAuC;CACvC,mBAAmB;CACnB,qBAAqB;CACrB,kBAAkB;AACnB;;AAEA;CACC,+CAA+C;CAC/C,mBAAmB;CACnB,aAAa;AACd;;AAEA;CACC,oGAAoG;CACpG,yBAAyB;AAC1B;;AAEA;CACC,aAAa;CACb,kCAAkC;CAClC,qBAAqB;CACrB,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,qBAAqB;CACrB,yBAA8B;KAA9B,sBAA8B;SAA9B,8BAA8B;AAC/B;;AAEA;CACC,oGAAoG;CACpG,yBAAyB;AAC1B;;AAEA;CACC,uCAAuC;CACvC,yCAAyC;CACzC,mBAAmB;CACnB,kBAAkB;CAClB,aAAa;AACd;;AAEA;CACC,uCAAuC;CACvC,aAAa;CACb,mBAAmB;AACpB;;AAEA;CACC,aAAa;CACb,8BAA8B;AAC/B;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,aAAa;CACb,kCAAkC;AACnC;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,WAAW;CACX,WAAW;CACX,YAAY;CACZ,yBAAyB;CACzB,0BAAkB;SAAlB,kBAAkB;CAClB,kBAAkB;CAClB,MAAM;CACN,OAAO;CACP,QAAQ;CACR,cAAc;AACf;;AAEA;CACC,kBAAkB;CAClB,UAAU;AACX;;AAEA;CACC,yBAAyB;AAC1B;;AAMA;CACC,cAAc;AACf;;AAEA,UAAU;;AACV;CACC,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,yBAA8B;KAA9B,sBAA8B;SAA9B,8BAA8B;CAC9B,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,mBAAe;KAAf,eAAe;CACf,SAAS;AACV;;AAEA;CACC,aAAa;CACb,qCAAqC;CACrC,SAAS;AACV;;AAEA,SAAS;;AAET;CACC,uCAAuC;CACvC,mBAAmB;AACpB;;AAEA;CACC,aAAa;CACb,8CAA8C;AAC/C;;AAEA;CACC,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,yBAA8B;KAA9B,sBAA8B;SAA9B,8BAA8B;CAC9B,SAAS;AACV;;AAEA;CACC,YAAY;CACZ,kBAAkB;CAClB,kCAAkC;CAClC,WAAW;CACX,YAAY;CACZ,aAAa;CACb,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,wBAAuB;KAAvB,qBAAuB;SAAvB,uBAAuB;CACvB,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,wBAAwB;CACxB,oBAAc;KAAd,cAAc;AACf;;AAEA;CACC,WAAW;CACX,YAAY;AACb;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,aAAa;CACb,qCAAqC;CACrC,SAAS;CACT,mBAAmB;CACnB,eAAe;AAChB;;AAEA;CACC,iCAAiC;CACjC,iBAAiB;AAClB;;AAEA;CACC,+BAA+B;CAC/B,eAAe;AAChB;;AAEA;CACC,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,qBAAoB;KAApB,kBAAoB;SAApB,oBAAoB;AACrB;;AAEA;CACC,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,QAAQ;CACR,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,eAAe;AAChB;;AAEA;CACC,UAAU;CACV,YAAY;CACZ,kBAAkB;CAClB,QAAQ;AACT;;AAEA;CACC,kBAAkB;CAClB,mBAAmB;CACnB,uCAAuC;CACvC,eAAe;CACf,2BAAoB;CAApB,2BAAoB;CAApB,oBAAoB;CACpB,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,QAAQ;CACR,uCAAuC;AACxC;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,oBAAc;KAAd,cAAc;AACf;;AAEA;CACC,aAAa;CACb,SAAS;AACV;;AAEA;;CAEC,aAAa;CACb,uCAAuC;CACvC,mBAAmB;AACpB;;AAEA;CACC,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,SAAS;CACT,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,0BAAwB;SAAxB;AACD;;AAEA;CACC,kBAAkB;CAClB,2BAA0B;SAA1B,0BAA0B;AAC3B;;AAEA;CACC,kBAAkB;CAClB,WAAW;CACX,UAAU;CACV,WAAW;CACX,uCAAuC;CACvC,kBAAkB;CAClB,OAAO;CACP,QAAQ;AACT;;AAEA;;CAEC,0CAA0C;AAC3C;;AAEA;CACC,gBAAgB;CAChB,+BAA+B;AAChC;;AAEA;CACC,iCAAiC;CACjC,eAAe;CACf,eAAe;AAChB;;AAEA;CACC,wBAAuB;KAAvB,qBAAuB;SAAvB,uBAAuB;AACxB;;AAEA;CACC,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,SAAS;CACT,mBAAe;KAAf,eAAe;CACf,yBAA8B;KAA9B,sBAA8B;SAA9B,8BAA8B;CAC9B,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;AACpB;;AAEA;CACC,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,yBAA8B;KAA9B,sBAA8B;SAA9B,8BAA8B;CAC9B,aAAa;CACb,uCAAuC;CACvC,gBAAgB;CAChB,0BAA0B;CAC1B,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,SAAS;CACT,mBAAe;KAAf,eAAe;AAChB;;AAEA,sBAAsB;;AACtB;CACC,kBAAkB;CAClB,UAAU;CACV,0BAAyB;SAAzB,yBAAyB;AAC1B;;AAEA;CACC,kBAAkB;CAClB,QAAQ;CACR,mBAAmB;CACnB,6CAAqC;SAArC,qCAAqC;CACrC,uCAAuC;CACvC,gBAAgB;CAChB,uBAAuB;CACvB,SAAS;AACV;;AAEA;CACC,aAAa;CACb,gCAAgC;AACjC;;AAEA;CACC,2BAAoB;CAApB,2BAAoB;CAApB,oBAAoB;CACpB,4BAAsB;CAAtB,6BAAsB;KAAtB,0BAAsB;SAAtB,sBAAsB;CACtB,wBAAuB;KAAvB,qBAAuB;SAAvB,uBAAuB;CACvB,yBAA8B;KAA9B,sBAA8B;SAA9B,8BAA8B;CAC9B,SAAS;CACT,aAAa;CACb,uCAAuC;CACvC,6CAA6C;AAC9C;;AAEA;CACC,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,4BAAsB;CAAtB,6BAAsB;KAAtB,0BAAsB;SAAtB,sBAAsB;CACtB,wBAAuB;KAAvB,qBAAuB;SAAvB,uBAAuB;CACvB,QAAQ;AACT;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,uBAAuB;CACvB,SAAS;CACT,iCAAiC;CACjC,eAAe;AAChB;;AAEA;CACC,uCAAuC;CACvC,iBAAiB;CACjB,iBAAiB;CACjB,kBAAkB;CAClB,+BAA+B;AAChC;;AAEA;CACC,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,QAAQ;CACR,eAAe;CACf,cAAc;AACf;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,SAAS;CACT,kBAAyC;CAAzC,yCAAyC;CACzC,eAAe;CACf,oBAAc;KAAd,cAAc;AACf;;AAEA;CACC,iCAAiC;CACjC,eAAe;AAChB;;AAEA;CACC,+BAA+B;CAC/B,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;CAChB,YAAY;CACZ,UAAU;CACV,eAAe;CACf,cAAwC;CAAxC,wCAAwC;CACxC,qBAAqB;CACrB,eAAe;CACf,gBAAgB;AACjB;;AAEA;CACC,0BAA0B;AAC3B;;AAEA;CACC,oBAAc;KAAd,cAAc;CACd,iBAAiB;AAClB;;AAEA;CACC,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,8BAAmB;CAAnB,6BAAmB;KAAnB,uBAAmB;SAAnB,mBAAmB;CACnB,yBAA8B;KAA9B,sBAA8B;SAA9B,8BAA8B;CAC9B,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,WAAW;CACX,SAAS;AACV;;AAEA;CACC,iBAAiB;CACjB,uCAAuC;CACvC,kBAAkB;CAClB,kBAAkB;CAClB,yBAAyB;CACzB,wBAAwB;CACxB,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,QAAQ;CACR,oEAA0E;CAC1E,4BAA4B;CAC5B,0CAA0C;CAC1C,qCAAqC;CACrC,eAAe;;AAEhB;;AAEA;CACC,mBAAmB;CACnB,gBAAgB;AACjB;;AAEA;CACC,WAAW;CACX,YAAY;AACb;;AAEA;CACC,aAAa;CACb,qCAAqC;CACrC,SAAS;CACT,eAAe;CACf,aAAa;CACb,uCAAuC;CACvC,mBAAmB;CACnB,iCAAiC;CACjC,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;AACpB;;AAEA;CACC,eAAe;CACf,+BAA+B;CAC/B,gBAAgB;AACjB;;AAEA;CACC,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,QAAQ;CACR,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;AACpB;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,kBAAkB;CAClB,oBAAc;KAAd,cAAc;AACf;;AAEA;CACC,aAAa;CACb,qCAAqC;CACrC,SAAS;CACT,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;;AAEpB;;AAEA;CACC,2BAAoB;CAApB,2BAAoB;CAApB,oBAAoB;CACpB,SAAS;CACT,4BAAsB;CAAtB,6BAAsB;KAAtB,0BAAsB;SAAtB,sBAAsB;CACtB,gBAAgB;AACjB;;AAEA;CACC,YAAY;CACZ,aAAa;CACb,YAAY;AACb;;AAEA;CACC,eAAe;CACf,gBAAgB;CAChB,kBAAkB;CAClB,kBAAkB;AACnB;;AAEA;CACC,6BAA6B;CAC7B,eAAe;CACf,SAAS;CACT,kBAAkB;AACnB;;AAEA;CACC,iBAAiB;CACjB,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,wBAAuB;KAAvB,qBAAuB;SAAvB,uBAAuB;CACvB,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,4BAAsB;CAAtB,6BAAsB;KAAtB,0BAAsB;SAAtB,sBAAsB;AACvB;;AAEA;CACC,kBAAkB;CAClB,SAAS;CACT,0BAAyB;SAAzB,yBAAyB;AAC1B;;AAEA;CACC;EACC,qCAAqC;CACtC;AACD;;AAEA;;CAEC;;EAEC,2BAA2B;CAC5B;AACD;;AAEA;;CAEC;;EAEC,2BAA2B;CAC5B;;CAEA;EACC,SAAS;EACT,4BAAQ;MAAR,iBAAQ;UAAR,QAAQ;EACR,eAAe;EACf,2CAA2C;CAC5C;;CAEA;EACC,eAAe;EACf,WAAW;EACX,kBAAkB;CACnB;;CAEA;EACC,4BAAQ;MAAR,iBAAQ;UAAR,QAAQ;EACR,cAAc;CACf;;CAEA;EACC,4BAAQ;MAAR,iBAAQ;UAAR,QAAQ;CACT;;CAEA;EACC,aAAa;CACd;;CAEA;EACC,4BAAsB;EAAtB,6BAAsB;MAAtB,0BAAsB;UAAtB,sBAAsB;EACtB,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;CACxB;;CAEA;EACC,2BAA0B;UAA1B,0BAA0B;EAC1B,mBAAe;MAAf,eAAe;CAChB;;CAEA;EACC,WAAW;CACZ;;CAEA;EACC,0BAA0B;CAC3B;;CAEA;EACC,gBAAgB;CACjB;AACD","sourcesContent":[".userBox {\n\tbox-shadow: 0px 11px 16px #DCD8FF73;\n\tborder: 2px solid var(--primary-border);\n\tborder-radius: 12px;\n\tpadding: 19px 0px 0px;\n\ttext-align: center;\n}\n\n.commonBg {\n\tbackground: #F4F2FF 0% 0% no-repeat padding-box;\n\tborder-radius: 12px;\n\tpadding: 20px;\n}\n\n.userBoxBG {\n\tbackground: transparent linear-gradient(62deg, #FFDFD9 0%, #A3B2FF 100%) 0% 0% no-repeat padding-box;\n\tborder: 2px solid #FFF8F2;\n}\n\n.displayGrid {\n\tdisplay: grid;\n\tgrid-template-columns: 33% 33% 33%;\n\tpadding: 33px 6px 0px;\n\talign-items: center;\n\tjustify-items: center;\n\tjustify-content: space-between;\n}\n\n.listingBoxBg {\n\tbackground: transparent linear-gradient(62deg, #FFD9FC 0%, #FFE991 100%) 0% 0% no-repeat padding-box;\n\tborder: 2px solid #FFF8F2;\n}\n\n.reservationBox {\n\tbackground: var(--common-gray-bg-color);\n\tborder: 2px solid var(--primary-white-bg);\n\tborder-radius: 12px;\n\ttext-align: center;\n\tpadding: 33px;\n}\n\n.reservationBg {\n\tborder: 1px solid var(--primary-border);\n\tpadding: 20px;\n\tborder-radius: 12px;\n}\n\n.columnGrid {\n\tdisplay: grid;\n\tgrid-template-columns: 50% 50%;\n}\n\n.marginOne {\n\tmargin: 0px 15px 30px 0px;\n}\n\n.marginTwo {\n\tmargin: 0px 0px 30px 15px;\n}\n\n.reservationGrid {\n\tdisplay: grid;\n\tgrid-template-columns: 32% 36% 32%;\n}\n\n.reservationMarginRight {\n\tmargin-right: 21px;\n}\n\n.reservationMarginLeft {\n\tmargin-left: 21px;\n}\n\n.backgroundBgBlur {\n\tposition: relative;\n}\n\n.backgroundBgBlur::after {\n\tcontent: '';\n\twidth: 72px;\n\theight: 72px;\n\tbackground-color: #FFD8B9;\n\tfilter: blur(17px);\n\tposition: absolute;\n\ttop: 0;\n\tleft: 0;\n\tright: 0;\n\tmargin: 0 auto;\n}\n\n.imgZindex {\n\tposition: relative;\n\tz-index: 2;\n}\n\n.backgroundBgBlurTwo::after {\n\tbackground-color: #FFB9B9;\n}\n\n\n\n\n\n.motheListing {\n\tdisplay: block;\n}\n\n/* start */\n.dashboardHeaderFlexWrapper {\n\tdisplay: flex;\n\tjustify-content: space-between;\n\talign-items: center;\n\tflex-wrap: wrap;\n\tgap: 12px;\n}\n\n.dashboardCardGridWrapper {\n\tdisplay: grid;\n\tgrid-template-columns: repeat(4, 1fr);\n\tgap: 24px;\n}\n\n/* card */\n\n.dashboardCard {\n\tborder: 1px solid var(--primary-border);\n\tborder-radius: 12px;\n}\n\n.dashboardCardHeaderWrapper {\n\tpadding: 18px;\n\tborder-bottom: 1px solid var(--primary-border);\n}\n\n.dashboardCardHeaderTitleFlex {\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: space-between;\n\tgap: 12px;\n}\n\n.dashboardCardIconWrapper {\n\tpadding: 8px;\n\tborder-radius: 8px;\n\tbackground: var(--icon-background);\n\twidth: 40px;\n\theight: 40px;\n\tpadding: 10px;\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\tcolor: var(--icon-color);\n\tflex-shrink: 0;\n}\n\n.dashboardCardIconWrapper svg {\n\twidth: 100%;\n\theight: 100%;\n}\n\n.dashboardEaringsReportWrapper {\n\tpadding: 18px;\n}\n\n.dashboardCardRow {\n\tdisplay: grid;\n\tgrid-template-columns: repeat(2, 1fr);\n\tgap: 12px;\n\tmargin-bottom: 12px;\n\tfont-size: 14px;\n}\n\n.dashboardCardRow>span:first-child {\n\tcolor: var(--tertiary-foreground);\n\ttext-align: start;\n}\n\n.dashboardCardRow>span:last-child {\n\tcolor: var(--common-text-color);\n\ttext-align: end;\n}\n\n.dashboardCardLinkContainer {\n\tdisplay: flex;\n\tjustify-content: end;\n}\n\n.dashboardCardLink {\n\tdisplay: flex;\n\tgap: 4px;\n\talign-items: center;\n\tfont-size: 14px;\n}\n\n.dashboardCardLink svg {\n\twidth: 6px;\n\theight: 10px;\n\tposition: relative;\n\ttop: 1px;\n}\n\n.dateRangeBatch {\n\tpadding: 10px 18px;\n\tborder-radius: 24px;\n\tbackground: var(--common-gray-bg-color);\n\tfont-size: 16px;\n\tdisplay: inline-flex;\n\talign-items: center;\n\tgap: 4px;\n\tborder: 1px solid var(--primary-border);\n}\n\n.dateRangeBatch svg {\n\twidth: 20px;\n\theight: 20px;\n\tflex-shrink: 0;\n}\n\n.dashboardRevenueAndPlatformEarningsGridWrapper {\n\tdisplay: grid;\n\tgap: 24px;\n}\n\n.dashboardRevenueCard,\n.platformEarningsCard {\n\tpadding: 18px;\n\tborder: 1px solid var(--primary-border);\n\tborder-radius: 12px;\n}\n\n.revenueChartDotWrapper {\n\tdisplay: flex;\n\tgap: 12px;\n\talign-items: center;\n\tmargin-inline-start: auto\n}\n\n.revenueChartDotWrapper .chartDotText {\n\tposition: relative;\n\tpadding-inline-start: 18px;\n}\n\n.revenueChartDotWrapper .chartDotText::before {\n\tposition: absolute;\n\tcontent: '';\n\twidth: 8px;\n\theight: 8px;\n\tbackground-color: var(--btn-primary-bg);\n\tborder-radius: 50%;\n\tleft: 0;\n\ttop: 4px;\n}\n\n.revenueChartDotWrapper .chartDotText:last-child::before,\n.revenueChartDotWrapper .chartDotTextFee::before {\n\tbackground-color: var(--common-link-color);\n}\n\n.revenueChartDotWrapper .chartDotTextFee {\n\tfont-weight: 500;\n\tcolor: var(--common-text-color);\n}\n\n.chartSectionHeaderFlex .revenueFeeSubtitle {\n\tcolor: var(--tertiary-foreground);\n\tfont-size: 14px;\n\tmargin-top: 4px;\n}\n\n.dashboardRevenueCard .chartSectionHeaderFlex {\n\talign-items: flex-start;\n}\n\n.chartSectionHeaderFlex {\n\tdisplay: flex;\n\tgap: 12px;\n\tflex-wrap: wrap;\n\tjustify-content: space-between;\n\talign-items: center;\n}\n\n.dashboardReservationTableHeader {\n\tdisplay: flex;\n\tjustify-content: space-between;\n\tpadding: 18px;\n\tborder: 1px solid var(--primary-border);\n\tborder-bottom: 0;\n\tborder-radius: 6px 6px 0 0;\n\talign-items: center;\n\tgap: 12px;\n\tflex-wrap: wrap;\n}\n\n/* date filter start */\n.dashboardDateFilterWrapper {\n\tposition: relative;\n\tz-index: 2;\n\tmargin-inline-start: auto;\n}\n\n.dashboardDateFilterPickerAndButtonWrapper {\n\tposition: absolute;\n\tright: 0;\n\tborder-radius: 12px;\n\tbox-shadow: 0px 5px 9px 1px #8080801f;\n\tborder: 1px solid var(--primary-border);\n\toverflow: hidden;\n\tbackground-color: white;\n\ttop: 52px;\n}\n\n.dashboardDateFilterPickerInnerWrapper {\n\tdisplay: grid;\n\tgrid-template-columns: 300px 1fr;\n}\n\n.dashboardDateFilterButtonWrapper {\n\tdisplay: inline-flex;\n\tflex-direction: column;\n\talign-items: flex-start;\n\tjustify-content: space-between;\n\tgap: 10px;\n\tpadding: 18px;\n\tbackground: var(--common-gray-bg-color);\n\tborder-right: 1px solid var(--primary-border);\n}\n\n.dashboardDateFilterButtonInnerWrapper {\n\tdisplay: flex;\n\tflex-direction: column;\n\talign-items: flex-start;\n\tgap: 4px;\n}\n\n.dashboardDateFilterButtonInnerWrapper label {\n\tmargin-bottom: 0;\n}\n\n.dashboardDateFilterButton {\n\tbackground: transparent;\n\tborder: 0;\n\tcolor: var(--tertiary-foreground);\n\tpadding: 0 12px;\n}\n\n.dashboardDateFilterButtonActive {\n\tborder: 1px solid var(--primary-border);\n\tbackground: white;\n\tpadding: 6px 12px;\n\tborder-radius: 6px;\n\tcolor: var(--common-text-color);\n}\n\n.dashboardDateFilterRadioLabel {\n\tdisplay: flex;\n\talign-items: center;\n\tgap: 8px;\n\tcursor: pointer;\n\tpadding: 2px 0;\n}\n\n.dashboardDateFilterRadioInput {\n\twidth: 18px;\n\theight: 18px;\n\tmargin: 0;\n\taccent-color: var(--btn-primary-bg, #000);\n\tcursor: pointer;\n\tflex-shrink: 0;\n}\n\n.dashboardDateFilterRadioText {\n\tcolor: var(--tertiary-foreground);\n\tfont-size: 14px;\n}\n\n.dashboardDateFilterRadioLabel:has(.dashboardDateFilterRadioInput:checked) .dashboardDateFilterRadioText {\n\tcolor: var(--common-text-color);\n\tfont-weight: 500;\n}\n\n.dateFilterClearLink {\n\tbackground: none;\n\tborder: none;\n\tpadding: 0;\n\tfont-size: 14px;\n\tcolor: var(--common-link-color, #0066cc);\n\ttext-decoration: none;\n\tcursor: pointer;\n\ttext-align: left;\n}\n\n.dateFilterClearLink:hover {\n\ttext-decoration: underline;\n}\n\n.dateFilterApplyButton {\n\tflex-shrink: 0;\n\tpadding: 4px 12px;\n}\n\n.dateFilterApplyAndClearButtonWrapper {\n\tdisplay: flex;\n\tflex-direction: row;\n\tjustify-content: space-between;\n\talign-items: center;\n\twidth: 100%;\n\tgap: 12px;\n}\n\n.dateFilterSelectContainer {\n\tbackground: white;\n\tborder: 1px solid var(--primary-border);\n\tborder-radius: 6px;\n\tpadding: 10px 12px;\n\t-webkit-padding-end: 30px;\n\tpadding-inline-end: 40px;\n\tdisplay: flex;\n\talign-items: center;\n\tgap: 4px;\n\tbackground-image: url('../../../../public/commonDownArrow.svg') !important;\n\tbackground-repeat: no-repeat;\n\tbackground-position: calc(100% - 15px) 50%;\n\tbackground-size: 12px 25px !important;\n\tfont-size: 16px;\n\n}\n\n.dateFilterSelectContainer span {\n\twhite-space: nowrap;\n\toverflow: hidden;\n}\n\n.dateFilterSelectContainer svg {\n\twidth: 20px;\n\theight: 20px;\n}\n\n.platformEarningsRow {\n\tdisplay: grid;\n\tgrid-template-columns: repeat(2, 1fr);\n\tgap: 12px;\n\tfont-size: 14px;\n\tpadding: 18px;\n\tborder: 1px solid var(--primary-border);\n\tborder-radius: 30px;\n\tcolor: var(--tertiary-foreground);\n\talign-items: center;\n}\n\n.platformEarningsRow>div:last-child {\n\ttext-align: end;\n\tcolor: var(--common-text-color);\n\tfont-weight: 500;\n}\n\n.platformEarningsRowDotFlexContainer {\n\tdisplay: flex;\n\tgap: 6px;\n\talign-items: center;\n}\n\n.platformEarningsRowDot {\n\twidth: 12px;\n\theight: 12px;\n\tborder-radius: 50%;\n\tflex-shrink: 0;\n}\n\n.platformEarningsCardInnerGrid {\n\tdisplay: grid;\n\tgrid-template-columns: repeat(2, 1fr);\n\tgap: 36px;\n\talign-items: center;\n\n}\n\n.platformEarningsRowWrapper {\n\tdisplay: inline-flex;\n\tgap: 24px;\n\tflex-direction: column;\n\tmax-width: 430px;\n}\n\n.platformEarningsChart {\n\twidth: 250px;\n\theight: 250px;\n\tmargin: auto;\n}\n\n.noDataTitle {\n\tfont-size: 18px;\n\tfont-weight: 600;\n\tmargin-bottom: 6px;\n\ttext-align: center;\n}\n\n.noDataDescription {\n\tcolor: var(--modalText-color);\n\tfont-size: 14px;\n\tmargin: 0;\n\ttext-align: center;\n}\n\n.platformEarningsCardNoData {\n\tmin-height: 200px;\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\tflex-direction: column;\n}\n\n.dateTooltipIcon {\n\tposition: relative;\n\ttop: -2px;\n\tpadding-inline-start: 2px;\n}\n\n@media screen and (max-width: 1300px) {\n\t.dashboardCardGridWrapper {\n\t\tgrid-template-columns: repeat(2, 1fr);\n\t}\n}\n\n@media screen and (max-width: 991px) {\n\n\t.dashboardCardGridWrapper,\n\t.dashboardRevenueAndPlatformEarningsGridWrapper {\n\t\tgrid-template-columns: 100%;\n\t}\n}\n\n@media screen and (max-width: 767px) {\n\n\t.dashboardDateFilterPickerInnerWrapper,\n\t.platformEarningsCardInnerGrid {\n\t\tgrid-template-columns: 100%;\n\t}\n\n\t.dashboardDateFilterButtonWrapper {\n\t\tgap: 24px;\n\t\torder: 2;\n\t\tborder-right: 0;\n\t\tborder-top: 1px solid var(--primary-border);\n\t}\n\n\t.dashboardDateFilterButton {\n\t\tfont-size: 16px;\n\t\twidth: 100%;\n\t\ttext-align: center;\n\t}\n\n\t.platformEarningsCardInnerGrid>div:first-child {\n\t\torder: 2;\n\t\tmargin: 0 auto;\n\t}\n\n\t.platformEarningsCardInnerGrid>div:last-child {\n\t\torder: 1;\n\t}\n\n\t.chartLabelHiddenMobile {\n\t\tdisplay: none;\n\t}\n\n\t.chartSectionHeaderFlex {\n\t\tflex-direction: column;\n\t\talign-items: flex-start;\n\t}\n\n\t.revenueChartDotWrapper {\n\t\tmargin-inline-start: unset;\n\t\tflex-wrap: wrap;\n\t}\n\n\t.dashboardDateFilterButtonInnerWrapper {\n\t\twidth: 100%;\n\t}\n\n\t.dateFilterApplyButton {\n\t\tfont-size: 14px !important;\n\t}\n\n\t.dateFilterSelectContainer {\n\t\tmax-width: 280px;\n\t}\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"userBox": `AdminDashboard-userBox-z48Me`,
	"commonBg": `AdminDashboard-commonBg-hOkVI`,
	"userBoxBG": `AdminDashboard-userBoxBG-NN6MD`,
	"displayGrid": `AdminDashboard-displayGrid-gTw7_`,
	"listingBoxBg": `AdminDashboard-listingBoxBg-lz5dG`,
	"reservationBox": `AdminDashboard-reservationBox-_BW6Q`,
	"reservationBg": `AdminDashboard-reservationBg-d4RGs`,
	"columnGrid": `AdminDashboard-columnGrid-svTzD`,
	"marginOne": `AdminDashboard-marginOne-wjOWr`,
	"marginTwo": `AdminDashboard-marginTwo-p45r7`,
	"reservationGrid": `AdminDashboard-reservationGrid-sDdmv`,
	"reservationMarginRight": `AdminDashboard-reservationMarginRight-tnyEi`,
	"reservationMarginLeft": `AdminDashboard-reservationMarginLeft-x0IVI`,
	"backgroundBgBlur": `AdminDashboard-backgroundBgBlur-Rqht3`,
	"imgZindex": `AdminDashboard-imgZindex-E2kqC`,
	"backgroundBgBlurTwo": `AdminDashboard-backgroundBgBlurTwo-Cp5Gd`,
	"motheListing": `AdminDashboard-motheListing-wMWbR`,
	"dashboardHeaderFlexWrapper": `AdminDashboard-dashboardHeaderFlexWrapper-ot7Y6`,
	"dashboardCardGridWrapper": `AdminDashboard-dashboardCardGridWrapper-ZaQbs`,
	"dashboardCard": `AdminDashboard-dashboardCard-htWwU`,
	"dashboardCardHeaderWrapper": `AdminDashboard-dashboardCardHeaderWrapper-fdLLX`,
	"dashboardCardHeaderTitleFlex": `AdminDashboard-dashboardCardHeaderTitleFlex-cdgDr`,
	"dashboardCardIconWrapper": `AdminDashboard-dashboardCardIconWrapper-G_KB_`,
	"dashboardEaringsReportWrapper": `AdminDashboard-dashboardEaringsReportWrapper-GXsmu`,
	"dashboardCardRow": `AdminDashboard-dashboardCardRow-b_Yqp`,
	"dashboardCardLinkContainer": `AdminDashboard-dashboardCardLinkContainer-aiZx1`,
	"dashboardCardLink": `AdminDashboard-dashboardCardLink-aRJur`,
	"dateRangeBatch": `AdminDashboard-dateRangeBatch-HZGZG`,
	"dashboardRevenueAndPlatformEarningsGridWrapper": `AdminDashboard-dashboardRevenueAndPlatformEarningsGridWrapper-sM8BF`,
	"dashboardRevenueCard": `AdminDashboard-dashboardRevenueCard-YXAdk`,
	"platformEarningsCard": `AdminDashboard-platformEarningsCard-RxgR_`,
	"revenueChartDotWrapper": `AdminDashboard-revenueChartDotWrapper-ujblY`,
	"chartDotText": `AdminDashboard-chartDotText-MWXs0`,
	"chartDotTextFee": `AdminDashboard-chartDotTextFee-_B8Yk`,
	"chartSectionHeaderFlex": `AdminDashboard-chartSectionHeaderFlex-hbpY1`,
	"revenueFeeSubtitle": `AdminDashboard-revenueFeeSubtitle-plimi`,
	"dashboardReservationTableHeader": `AdminDashboard-dashboardReservationTableHeader-ytHwq`,
	"dashboardDateFilterWrapper": `AdminDashboard-dashboardDateFilterWrapper-J6sen`,
	"dashboardDateFilterPickerAndButtonWrapper": `AdminDashboard-dashboardDateFilterPickerAndButtonWrapper-GGv34`,
	"dashboardDateFilterPickerInnerWrapper": `AdminDashboard-dashboardDateFilterPickerInnerWrapper-mFma5`,
	"dashboardDateFilterButtonWrapper": `AdminDashboard-dashboardDateFilterButtonWrapper-fvSi4`,
	"dashboardDateFilterButtonInnerWrapper": `AdminDashboard-dashboardDateFilterButtonInnerWrapper-LrA5g`,
	"dashboardDateFilterButton": `AdminDashboard-dashboardDateFilterButton-jzGKT`,
	"dashboardDateFilterButtonActive": `AdminDashboard-dashboardDateFilterButtonActive-GZIOR`,
	"dashboardDateFilterRadioLabel": `AdminDashboard-dashboardDateFilterRadioLabel-eNKzU`,
	"dashboardDateFilterRadioInput": `AdminDashboard-dashboardDateFilterRadioInput-iIh6n`,
	"dashboardDateFilterRadioText": `AdminDashboard-dashboardDateFilterRadioText-cI6ZC`,
	"dateFilterClearLink": `AdminDashboard-dateFilterClearLink-K0Kaw`,
	"dateFilterApplyButton": `AdminDashboard-dateFilterApplyButton-mwbA0`,
	"dateFilterApplyAndClearButtonWrapper": `AdminDashboard-dateFilterApplyAndClearButtonWrapper-bT1Ha`,
	"dateFilterSelectContainer": `AdminDashboard-dateFilterSelectContainer-iRVc3`,
	"platformEarningsRow": `AdminDashboard-platformEarningsRow-bPm20`,
	"platformEarningsRowDotFlexContainer": `AdminDashboard-platformEarningsRowDotFlexContainer-xOHXv`,
	"platformEarningsRowDot": `AdminDashboard-platformEarningsRowDot-beKz9`,
	"platformEarningsCardInnerGrid": `AdminDashboard-platformEarningsCardInnerGrid-IaNFa`,
	"platformEarningsRowWrapper": `AdminDashboard-platformEarningsRowWrapper-ihmOC`,
	"platformEarningsChart": `AdminDashboard-platformEarningsChart-V4RkW`,
	"noDataTitle": `AdminDashboard-noDataTitle-umUrF`,
	"noDataDescription": `AdminDashboard-noDataDescription-rywUI`,
	"platformEarningsCardNoData": `AdminDashboard-platformEarningsCardNoData-bZ3UO`,
	"dateTooltipIcon": `AdminDashboard-dateTooltipIcon-sO0Ss`,
	"chartLabelHiddenMobile": `AdminDashboard-chartLabelHiddenMobile-MkkOT`
};
module.exports = ___CSS_LOADER_EXPORT___;
